
var countdown = document.getElementById("webinar-banner__countdown");

if (countdown) {
  if (countdown.dataset.timezoneDatetime !== "") {
    // Set the date we're counting down to
    var countdown2 = document.getElementById("webinar-banner__countdown-2"),
    countDownDate = new Date(countdown.dataset.timezoneDatetime).getTime(),
    countdownDay = countdown.querySelector(".webinar-banner__countdown-day"),
    countdownHour = countdown.querySelector(".webinar-banner__countdown-hour"),
    countdownMin = countdown.querySelector(".webinar-banner__countdown-min"),
    countdownSec = countdown.querySelector(".webinar-banner__countdown-sec");

    if (countdown2) {
      countdown2.classList.add("style-2");
      countdown2.classList.add("webinar-banner__countdown");
    }

    // Update the count down every 1 second
    var x = setInterval(function() {

      var now = new Date().getTime(), // Get today's date and time
        distance = countDownDate - now, // Find the distance between now and the count down date
        //Time calculations for days, hours, minutes and seconds
        days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        days = (days.toString().length == 1 ? "0" : "") + days.toString();
        hours = (hours.toString().length == 1 ? "0" : "") + hours.toString();
        minutes = (minutes.toString().length == 1 ? "0" : "") + minutes.toString();
        seconds = (seconds.toString().length == 1 ? "0" : "") + seconds.toString();

        //update days
        if (countdownDay.textContent != days) {
          countdownDay.innerHTML = days;
        }

        //update hour
        if (countdownHour.textContent != hours) {
          countdownHour.innerHTML = hours;
        }

        //update min
        if (countdownMin.textContent != minutes) {
          countdownMin.innerHTML = minutes;
        }

        //update sec
        if (countdownSec.textContent != seconds) {
          countdownSec.innerHTML = seconds;
        }

        if (countdown2) {
          countdown2.innerHTML = countdown.innerHTML;
        }
        
      // If the count down is over, write some text 
      if (distance < 0) {
        countdownDay.innerHTML = "00";
        countdownHour.innerHTML = "00";
        countdownMin.innerHTML = "00";
        countdownSec.innerHTML = "00";

        //hide
        countdown.classList.add("hide");

        if (countdown2) {
          //hide
          countdown2.classList.add("hide");
        }

        if (countdown2) {
          countdown2.innerHTML = countdown.innerHTML;
        }

        clearInterval(x);
      }
    }, 1000);
  }
}

